<div>
  <button (click)="clickButton()">{{text}}</button>
</div>
